import { createApp } from "vue";
import App from "./app.vue";

import treeMap from "highcharts/modules/treemap";
import Highcharts from "highcharts";

treeMap(Highcharts);

import { $axios } from "~/core/axios";
import { router } from "./router";

import "~/assets/styles/reset.css";
import "~/assets/styles/main.css";

const app = createApp(App);

app.config.globalProperties.$axios = $axios;

app.use(router);

app.mount("#app");

